import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface apiState {
    image_api: string;
    api: string;
    public_content_api: string;
}

const initialState: apiState = {
    api: "",
    image_api: "",
    public_content_api: ""
};

const apiSlice = createSlice({
    name: "api",
    initialState,
    reducers: {
        setApi: (state, data: PayloadAction<apiState>) => {
            state.api = data.payload.api;
            state.image_api = data.payload.image_api;
            state.public_content_api = data.payload.public_content_api
        },
    },
});

export const { setApi } = apiSlice.actions;
export default apiSlice.reducer;
